import { useEffect, useState } from 'react'

import Image from '../Image/Image'
import styles from './ToastMessage.module.scss'
import accept from '../../../assets/images/accept.svg'

function ToastMessage({ message, duration = 4000, onHide }) {
  const [visible, setVisible] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false)
      onHide()
    }, duration)
    return () => clearTimeout(timer)
  }, [duration, onHide])

  if (!visible) return null

  return (
    <div className={styles.popupStyle}>
      <Image src={accept} alt={message} />
      <span>{message}</span>
    </div>
  )
}

export default ToastMessage
